<template>
    <div class="simple-customer-result">
        <div class="mb-2 d-flex justify-space-between align-center">
            <h1 class="title mb-2">{{ resultTitle || 'Suchergebnisse' }}</h1>
        </div>
        <v-data-table
            :headers="headers"
            :items="result"
            :loading="loading"
            footer-props.items-per-page-text=""
            :no-data-text="emptyResultMessage"
            hide-default-footer
            disable-pagination
        >
            <template slot="item" slot-scope="props">
                <tr>
                    <td @click="doubleClick(props.item)">
                        {{ props.item.ssoId || 'Existiert nicht in CeleraOne' }}
                    </td>
                    <td @click="doubleClick(props.item, props.index)">
                        {{ props.item.gpIdsAsString }}
                    </td>
                    <td @click="doubleClick(props.item, props.index)">
                        <SimpleCustomerResultMail
                            class="simple-customer-result__different-mail-in-sap"
                            :sapData="props.item.sapData"
                            :sapMail="props.item.sapMail"
                            :login="props.item.login"
                            :ssoId="props.item.ssoId"
                            @afterUpdate="reloadResult"
                        />
                    </td>
                    <td @click="doubleClick(props.item, props.index)">{{ props.item.name }}</td>
                    <td @click="doubleClick(props.item, props.index)">{{ props.item.createdAt | toDatetime}}</td>
                    <td @click="doubleClick(props.item, props.index)">{{ props.item.lastLogin | toDatetime}}</td>
                    <td class="d-flex">
                        <div v-if="isLeserserviceOrHigher" class="flex-none">
                            <v-tooltip left>
                                <template #activator="{ on }">
                                    <v-btn
                                        v-on="on"
                                        text
                                        icon
                                        class="drei_60-black-text"
                                        @click="showDetails(props.item)"
                                    >
                                        <v-icon>mdi-account-circle</v-icon>
                                    </v-btn>
                                </template>
                                <span>Nutzerdetails</span>
                            </v-tooltip>
                        </div>
                        <EditEmail v-if="props.item.existInC1" :ssoId="props.item.ssoId || ''" />
                        <ResetPassword v-if="props.item.existInC1" :ssoId="props.item.ssoId || ''" />
                        <DeleteCustomerBtn v-if="props.item.deletable" :ssoId="props.item.ssoId || ''" @close="reloadResult"></DeleteCustomerBtn>
                    </td>
                </tr>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import Route from '@/route';
import EditEmail from '@/components/customer/EditEmail.vue';
import DeleteCustomerBtn from '@/components/customer/DeleteCustomerBtn.vue';
import ResetPassword from '@/components/customer/ResetPassword.vue';
import SimpleCustomerResultMail from '@/components/customer/SimpleCustomerResultMail.vue';

export default {
    name: 'SimpleCustomerResult',
    components: {
        EditEmail,
        ResetPassword,
        DeleteCustomerBtn,
        SimpleCustomerResultMail,
    },
    data() {
        return {
            headers: [{
                text: 'SSO ID',
                align: 'left',
                sortable: true,
                value: 'ssoId',
            }, {
                text: 'GP ID(s)',
                align: 'left',
                sortable: true,
                value: 'gpIdsAsString',
            }, {
                text: 'Login',
                align: 'left',
                sortable: true,
                value: 'login',
            }, {
                text: 'Name',
                align: 'left',
                sortable: true,
                value: 'name',
            }, {
                text: 'Erstellt am',
                align: 'left',
                sortable: true,
                value: 'createdAt',
            }, {
                text: 'Letzter Login',
                align: 'left',
                sortable: true,
                value: 'lastLogin',
            }, {
                text: 'Aktionen',
                align: 'left',
                sortable: false,
                value: 'ssoId',
            }],
            lastClickedIndex: -1,
            delay: 700,
            clicks: 0,
            timer: null,
        };
    },
    computed: {
        ...mapState('simpleSearch', [
            'loading',
            'result',
            'emptyResultMessage',
            'resultTitle',
            'gpnumber',
        ]),
        ...mapGetters(['isLeserserviceOrHigher']),
    },
    methods: {
        ...mapActions('simpleSearch', [
            'reloadResult',
        ]),
        showDetails(customer) {
            if (customer.existInC1) {
                this.$router.push({
                    name: Route.CUSTOMER_C1.name,
                    params: { sso_id: customer.ssoId },
                });
            } else {
                this.$router.push({
                    name: Route.CUSTOMER_MSP.name,
                    params: { gp_id: customer.gpIds[0].id, scope: customer.gpIds[0].scope },
                });
            }
        },
        doubleClick(customer, index) {
            this.clicks += 1;
            if (this.clicks === 1) {
                const self = this;
                this.timer = setTimeout(() => {
                    self.clicks = 0;
                }, this.delay);
            } else if (this.lastClickedIndex === index) {
                this.showDetails(customer);
                clearTimeout(this.timer);
                this.clicks = 0;
            } else {
                const self = this;
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    self.clicks = 0;
                }, this.delay);
                this.clicks = 1;
            }
            this.lastClickedIndex = index;
        },
    },
};
</script>

<style scoped lang="scss"></style>
